
import React from 'react';
import Card from '../../../components/base/Card';

export default function HowItWorks() {
  const steps = [
    {
      step: '01',
      title: 'あなたを知る ✍️',
      description: '「行きたい場所」や「日数」はもちろん、あなたの趣味や旅のスタイルをAIに教えてください。パーソナライズの旅の準備は最小限でOKです。',
      defaultImage: '/images/bceeb774bdf2f31461e61ded1ab957eb.png',
    },
    {
      step: '02',
      title: '直感で選ぶ ❤️',
      description: 'AIが提案する魅力的なスポット写真を、フリックするだけで直感的に「行きたい！」をリストアップ。ゲーム感覚で旅の骨格が完成します。',
      defaultImage: '/images/5f531f1f9b247f626c9b70b448fe4bd3.png',
    },
    {
      step: '03',
      title: 'AIがしおりを完成させる 🚀',
      description: 'あなたが選んだスポットをベースに、移動時間、開館時間、効率まで計算し最適な旅行プランをAIが自動生成。あとは出発を待つだけです。',
      defaultImage: '/images/deb64b136338f9d7a8989ba498e1f97c.png',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#111827] mb-6">
            使い方は簡単3ステップ
          </h2>
          <p className="text-xl text-[#6B7280] max-w-3xl mx-auto leading-relaxed">
            AIが最適な旅行プランを提案。友達と共有して、みんなで楽しい旅を計画しよう
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connection lines */}
          <div className="hidden md:block absolute top-1/2 left-1/3 w-1/3 h-0.5 bg-gradient-to-r from-[#02D0F0] to-[#07DBCA] transform -translate-y-1/2"></div>
          <div className="hidden md:block absolute top-1/2 right-1/3 w-1/3 h-0.5 bg-gradient-to-r from-[#02D0F0] to-[#07DBCA] transform -translate-y-1/2"></div>

          {steps.map((step, index) => (
            <div key={index} className="relative">
              <Card className="p-8 text-center relative z-10 bg-white">
                {/* STEP番号を上に移動 */}
                <div className="text-2xl font-bold text-[#02D0F0] mb-6">
                  STEP {step.step}
                </div>

                {/* スマホ画像表示エリア */}
                <div className="w-48 h-80 mx-auto mb-6">
                  <img
                    src={step.defaultImage}
                    alt={`ステップ${step.step}のスマホ画面`}
                    className="w-full h-full object-contain rounded-2xl shadow-lg"
                  />
                </div>

                <h3 className="text-2xl font-bold text-[#111827] mb-4">
                  {step.title}
                </h3>
                <p className="text-[#6B7280] leading-relaxed">
                  {index === 1 ? (
                    <>
                      AIが提案する魅力的なスポット写真を、<strong>フリックするだけで直感的</strong>に「行きたい！」をリストアップ。ゲーム感覚で旅の骨格が完成します。
                    </>
                  ) : index === 2 ? (
                    <>
                      あなたが選んだスポットをベースに、移動時間、開館時間、効率まで計算し<strong>最適な旅行プランをAIが自動生成</strong>。あとは出発を待つだけです。
                    </>
                  ) : (
                    step.description
                  )}
                </p>
              </Card>
            </div>
          ))}
        </div>
        
        {/* 削除: 説明テキスト */}
      </div>
    </section>
  );
}
